import { faHourglass as faHourglassRegular } from "@fortawesome/pro-regular-svg-icons/faHourglass";
import { faSpinner } from "@fortawesome/pro-solid-svg-icons/faSpinner";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from "react";
import { WithTranslation, withTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////////

export enum CallServerState { None, Loading, Saving, Error }

////////////////////////////////////////////////////////////////////////////////////

interface IState {
    activeElement: HTMLElement;
}

interface IProps {
    type?: "post" | "request" | "waiting";
    open?: boolean;
}

type Props = IProps & WithTranslation;

class RequestIndicatorComponent extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        this.state = { activeElement: props.open ? document.activeElement as HTMLElement : null };
    }

    static defaultProps: Partial<Props> = { type: "request" };

    private leaveFocus() {
        if (this.state.activeElement?.tagName == "INPUT") this.state.activeElement.blur();
    }

    private returnFocus() {
        if (this.state.activeElement?.tagName == "INPUT") this.state.activeElement.focus();
    }

    private checkNewState(prevProps: Props) {
        if (prevProps.open != this.props.open) {
            if (this.props.open) {
                this.setState({ activeElement: document.activeElement as HTMLElement }, () => this.leaveFocus());
            }
            else {
                this.returnFocus();
                this.setState({ activeElement: null });
            }
        }
    }

    componentDidMount() {
        if (this.props.open) this.leaveFocus();
    }

    componentDidUpdate(prevProps: Props) {
        this.checkNewState(prevProps);
    }

    componentWillUnmount() {
        this.returnFocus();
    }

    render() {
        const { t, open, type } = this.props;

        if (open === false) return null;

        return (
            <div className="genie-backdrop">
                <div className="genie-request-indicator__outer">
                    <div className="genie-request-indicator__inner">
                        <FontAwesomeIcon
                            size="2x"
                            fixedWidth
                            spin={type == "waiting"}
                            icon={
                                type == "post"
                                    ? faHourglassRegular
                                    : type == "request"
                                        ? faHourglassRegular
                                        : faSpinner

                            }
                        />
                        <br />
                        <br />
                        <span>
                            {
                                type == "post"
                                    ? t("Components.AxiosHandler.Indicator.Post")
                                    : type == "request"
                                        ? t("Components.AxiosHandler.Indicator.Request")
                                        : t("Components.AxiosHandler.Indicator.Wait")
                            }
                        </span>
                    </div>
                </div>
            </div>
        );
    }
};

export const RequestIndicator = withTranslation()(RequestIndicatorComponent);